import type { Configuration, CreateOAuthAppRequest } from '@repo/api-gw-sdk';
import { AiAgentApi, OauthAppsApi } from '@repo/api-gw-sdk';

import type { HttpClient } from './httpClient';

export const aiAgents = (httpClient: HttpClient, config: Configuration) => {
  const oauthAppsApi = new OauthAppsApi(config);
  const aiAgentApi = new AiAgentApi(config);

  return {
    useList: () =>
      httpClient.execute(
        oauthAppsApi.listOAuthApps.bind(oauthAppsApi),
        '/oauth-apps',
        ''
      ),
    create: (request: CreateOAuthAppRequest) =>
      oauthAppsApi.createOAuthApp(request),
    getAgentCard: () => aiAgentApi.getAIAgentCard(),
  };
};
